import React from 'react';
import styled from 'styled-components';

const BalloonSVG = styled.svg`
  position: absolute;
  bottom: 0;
  right: 0;
`;

function Balloon(data) {
  return (
    <BalloonSVG
      width="100"
      height="120"
      viewBox="0 0 100 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={data.lineColor}
    >
      {/* 왼쪽 말풍선 */}
      <g className="left-balloon">
        <path
          d="M24.5 99C24.5 104.799 19.799 109.5 14 109.5C8.20101 109.5 3.5 104.799 3.5 99C3.5 93.201 8.20101 88.5 14 88.5C15.5313 88.5 16.9847 88.8275 18.2952 89.4157C18.5574 89.5334 18.8397 89.5029 19.0553 89.4527C19.284 89.3994 19.528 89.3018 19.7676 89.1889C20.2133 88.9789 20.7215 88.678 21.2036 88.3926C21.2391 88.3715 21.2745 88.3506 21.3097 88.3297C21.8385 88.017 22.327 87.7329 22.7255 87.5618C22.8976 87.488 23.0304 87.4453 23.1268 87.4265C23.1258 87.5299 23.1102 87.6727 23.0762 87.8572C22.9958 88.2924 22.8356 88.8454 22.6612 89.4352C22.6499 89.4733 22.6386 89.5115 22.6272 89.5499C22.4671 90.0905 22.3003 90.6536 22.2002 91.1258C22.1467 91.3783 22.107 91.6278 22.1019 91.8477C22.0975 92.0413 22.1145 92.3297 22.2903 92.5555C23.6753 94.3345 24.5 96.5702 24.5 99ZM23.2395 87.4164C23.2394 87.4164 23.2384 87.4163 23.2366 87.4159C23.2386 87.4161 23.2395 87.4163 23.2395 87.4164ZM23.118 87.3045C23.1167 87.3013 23.1163 87.2995 23.1164 87.2994C23.1165 87.2993 23.1171 87.3009 23.118 87.3045Z"
          fill="white"
          stroke={data.lineColor}
        />
        <path
          d="M8 95L17 94L11.5 104.5L20 100.5M10.5 99L17.5 98"
          stroke={'#000'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* <path
            d="M12.5 104C13 100 17 99 18.5 103.5M9 94.5C10.8333 95.6667 13.4 98.7 9 101.5M21 96.5C20 98 13 99.5 15 93"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          /> */}
      </g>
      {/* 오른쪽 말풍선 */}
      <g className="right-balloon">
        <path
          d="M75.5 99C75.5 104.799 80.201 109.5 86 109.5C91.799 109.5 96.5 104.799 96.5 99C96.5 93.201 91.799 88.5 86 88.5C84.4687 88.5 83.0153 88.8275 81.7048 89.4157C81.4426 89.5334 81.1603 89.5029 80.9447 89.4527C80.716 89.3994 80.472 89.3018 80.2324 89.1889C79.7867 88.9789 79.2785 88.678 78.7964 88.3926C78.7609 88.3715 78.7255 88.3506 78.6903 88.3297C78.1615 88.017 77.673 87.7329 77.2745 87.5618C77.1024 87.488 76.9696 87.4453 76.8732 87.4265C76.8742 87.5299 76.8898 87.6727 76.9238 87.8572C77.0042 88.2924 77.1644 88.8454 77.3388 89.4352C77.3501 89.4733 77.3614 89.5115 77.3728 89.5499C77.5329 90.0905 77.6997 90.6536 77.7998 91.1258C77.8533 91.3783 77.893 91.6278 77.8981 91.8477C77.9025 92.0413 77.8855 92.3297 77.7097 92.5555C76.3247 94.3345 75.5 96.5702 75.5 99ZM76.7605 87.4164C76.7606 87.4164 76.7616 87.4163 76.7634 87.4159C76.7614 87.4161 76.7605 87.4163 76.7605 87.4164ZM76.882 87.3045C76.8833 87.3013 76.8837 87.2995 76.8836 87.2994C76.8835 87.2993 76.8829 87.3009 76.882 87.3045Z"
          fill="white"
          stroke={data.lineColor}
        />
        <path
          d="M83.5 104C84 100 88 99 89.5 103.5M80 94.5C81.8333 95.6667 84.4 98.7 80 101.5M92 96.5C91 98 84 99.5 86 93"
          stroke={data.lineColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </BalloonSVG>
  );
}

export default Balloon;
